import App from "./components/App.vue";
import Column from "package-common-vuejs/src/components/Column";
import Error404Layout from "package-common-vuejs/src/layouts/Error404Layout";
import FormActions from "package-common-vuejs/src/components/form/FormActions";
import FormButton from "package-common-vuejs/src/components/form/FormButton";
import FormCheckbox from "package-common-vuejs/src/components/form/FormCheckbox";
import FormDate from "package-common-vuejs/src/components/form/FormDate";
import FormFieldset from "package-common-vuejs/src/components/form/FormFieldset";
import FormGroup from "package-common-vuejs/src/components/form/FormGroup";
import FormInput from "package-common-vuejs/src/components/form/FormInput";
import FormRadio from "package-common-vuejs/src/components/form/FormRadio";
import FormSelect from "package-common-vuejs/src/components/form/FormSelect";
import FormTextarea from "package-common-vuejs/src/components/form/FormTextarea";
import LayoutSignedIn from "./components/LayoutSignedIn.vue";
import LayoutSignedOut from "./components/LayoutSignedOut.vue";
import Panel from "package-common-vuejs/src/components/Panel";
// Most frequently used components
import Row from "package-common-vuejs/src/components/Row";
import Vue from "vue";
import VueApollo from "vue-apollo";
import VueResource from "vue-resource";
import VueRouter from "vue-router";
import { client as apolloClient } from "./apollo";
import _forIn from "lodash/forIn";
import filters from "./filters";
import menu from "./menu";
import store from "./store";

//import 'package-common-vuejs/dist/package-common-vuejs.css';



Vue.use(VueApollo);
Vue.use(VueRouter);
Vue.use(VueResource);

const requireComponents = require.context("./components", true, /\.vue$/);
requireComponents.keys().forEach(key => {
  const component = requireComponents(key);
  let name = key.substring(key.lastIndexOf("/") + 1);
  name = name.substring(0, name.lastIndexOf(".vue"));
  name = name.substring(0, 1).toLowerCase() + name.substring(1);
  Vue.component(name, component);
});

Vue.component("Row", Row);
Vue.component("Column", Column);
Vue.component("Panel", Panel);
Vue.component("FormActions", FormActions);
Vue.component("FormButton", FormButton);
Vue.component("FormCheckbox", FormCheckbox);
Vue.component("FormDate", FormDate);
Vue.component("FormFieldset", FormFieldset);
Vue.component("FormGroup", FormGroup);
Vue.component("FormInput", FormInput);
Vue.component("FormSelect", FormSelect);
Vue.component("FormRadio", FormRadio);
Vue.component("FormTextarea", FormTextarea);

_forIn(filters, (value, prop) => {
  Vue.filter(prop, value);
});

Vue.mixin({
  computed: {
    pageTitle() {
      return (this.$route.meta && this.$route.meta.title) || this.$route.name;
    }
  }
});

const routes = [
  { path: "/login", component: LayoutSignedOut, meta: { title: "Connexion" } },
  {
    path: "/",
    component: LayoutSignedIn,
    props: { menu },
    meta: { breadcrumb: "Accueil", title: "Accueil" },
    beforeEnter(to, from, next) {
      if (!store.state.user) {
        return next({ path: "/login", query: { referer: to.fullPath } });
      }
      return next();
    },
    children: menu
  },
  {
    path: "*",
    meta: { title: "Page non trouvée" },
    component: Error404Layout
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title ||
    to.meta.name ||
    to.name} - Administration Netexial`;
  next();
});

new Vue({
  router,
  store,
  apolloProvider: new VueApollo({
    defaultClient: apolloClient
  }),
  el: "body",
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/index.js